export default __webpack_public_path__ + "static/media/angular.da89315f.jpg";